let container;

function getContainer() {
  if (!container) {
    container = document.createElement('div');
    container.id = 'toast-root';
    container.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);z-index:9999;display:flex;flex-direction:column;gap:8px;align-items:center;pointer-events:none';
    document.body.append(container);
  }
  return container;
}

function show(message, { variant = 'default', duration = 3000 } = {}) {
  const el = document.createElement('div');
  const colors = {
    success: { bg: 'var(--success)', icon: '✓' },
    error:   { bg: 'var(--danger)',  icon: '✕' },
    warning: { bg: 'var(--warning)', icon: '!' },
    info:    { bg: 'var(--info)',    icon: 'i' },
    default: { bg: 'var(--text-primary)', icon: '' },
  };
  const { bg, icon } = colors[variant] || colors.default;

  el.style.cssText = `
    display:inline-flex;align-items:center;gap:8px;
    padding:10px 18px;border-radius:var(--r-full);
    background:${bg};color:#fff;
    font-family:var(--font);font-size:var(--text-sm);font-weight:500;
    box-shadow:var(--shadow-md);
    pointer-events:auto;
    animation:toast-in .2s ease;
    white-space:nowrap;max-width:calc(100vw - 48px);
  `;

  const style = document.createElement('style');
  if (!document.getElementById('toast-keyframes')) {
    style.id = 'toast-keyframes';
    style.textContent = '@keyframes toast-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}';
    document.head.append(style);
  }

  if (icon) {
    const iconEl = document.createElement('span');
    iconEl.style.cssText = 'font-weight:700;font-size:12px;opacity:0.9';
    iconEl.textContent = icon;
    el.append(iconEl);
  }

  const text = document.createElement('span');
  text.textContent = message;
  el.append(text);

  getContainer().append(el);

  setTimeout(() => {
    el.style.opacity = '0';
    el.style.transition = 'opacity .2s';
    setTimeout(() => el.remove(), 200);
  }, duration);
}

export const toast = {
  success: (msg, opts) => show(msg, { variant: 'success', ...opts }),
  error:   (msg, opts) => show(msg, { variant: 'error',   ...opts }),
  warning: (msg, opts) => show(msg, { variant: 'warning', ...opts }),
  info:    (msg, opts) => show(msg, { variant: 'info',    ...opts }),
  show,
};
